import BlogPostImage from "./BlogPostImage";

const BlogPostImageWithProps = ({ blok }) => {
  return <BlogPostImage image={blok.image} caption={blok.caption} />;
};

export default BlogPostImageWithProps;
